// TODO: use next/image component!
/* eslint-disable @next/next/no-img-element */
import Modal from '@portalterreno/react-ui-core/Modal';
import GridOnRounded from '@portalterreno/react-ui-icons/GridOnRoundedIcon';
import MapOutlinedIcon from '@portalterreno/react-ui-icons/MapOutlinedIcon';
import ThreeSixtyIcon from '@portalterreno/react-ui-icons/ThreeSixtyIcon';
import React, { useEffect } from 'react';

import useProperty from '../../../hooks/useProperty';
import { PropertyProviderProps } from '../../../providers/PropertyProvider';
import Map from './Map';
import Masterplan from './Masterplan';
import ModalMasterplan from './ModalMasterplan';
import StyledSpan from './StyledSpan';
import Tab from './Tab';

type TabKey = 'tourvirtual' | 'masterplan' | 'map';

function calculateTabKey(property: PropertyProviderProps): TabKey {
  if (property.virtualTourUrl) {
    return 'tourvirtual';
  }
  if (property.masterPlanUrl) {
    return 'masterplan';
  }

  return 'map';
}

const LocationTabs: React.FC = () => {
  const property = useProperty();
  const [display, setDisplay] = React.useState<TabKey>(
    calculateTabKey(property)
  );

  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = React.useCallback(() => {
    setOpenModal(true);
  }, []);

  const handleCloseModal = React.useCallback(() => {
    setOpenModal(false);
  }, []);

  const handleOnClickTourVirtual = React.useCallback(() => {
    setDisplay('tourvirtual');
  }, []);

  const handleOnClickMasterplan = React.useCallback(() => {
    setDisplay('masterplan');
  }, []);

  const handleOnClickMap = React.useCallback(() => {
    setDisplay('map');
  }, []);

  useEffect(() => {
    setDisplay(calculateTabKey(property));
  }, [property]);

  return (
    <div>
      <div>
        {property.virtualTourUrl && (
          <Tab
            active={display === 'tourvirtual'}
            onClick={handleOnClickTourVirtual}
          >
            <ThreeSixtyIcon />
            <StyledSpan>Tour Virtual</StyledSpan>
          </Tab>
        )}
        {property.masterPlanUrl && (
          <Tab
            active={display === 'masterplan'}
            onClick={handleOnClickMasterplan}
          >
            <GridOnRounded />
            <StyledSpan>Master Plan</StyledSpan>
          </Tab>
        )}
        <Tab
          active={display === 'map'}
          onClick={handleOnClickMap}
        >
          <MapOutlinedIcon />
          <StyledSpan>Mapa</StyledSpan>
        </Tab>
      </div>
      {property.virtualTourUrl && display === 'tourvirtual' && (
        <iframe
          src={property.virtualTourUrl}
          width='100%'
          height={500}
        />
      )}
      {property.masterPlanUrl && display === 'masterplan' && (
        <div>
          <Masterplan
            src={property.masterPlanUrl}
            alt='Master Plan'
            onClick={handleOpenModal}
          />
          <Modal
            isOpen={openModal}
            onClose={handleCloseModal}
            onBackdropClick={handleCloseModal}
            onClick={handleCloseModal}
          >
            <ModalMasterplan src={property.masterPlanUrl} />
          </Modal>
        </div>
      )}
      {display === 'map' &&
        (property.latitude && property.longitude ? (
          <Map
            latitude={property.latitude}
            longitude={property.longitude}
            mapPreview={property.mapPreview}
            zoom={property.zoom}
          />
        ) : (
          <img
            alt='no_map'
            src={`${process.env.NEXT_PUBLIC_IMAGES_HOST}/maps/no_map.png`}
            width='100%'
            height='375'
          />
        ))}
    </div>
  );
};

export default LocationTabs;
